var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 431.45 85.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#005eb5;}.cls-2,.cls-5{fill:#4ca7e0;}.cls-3{fill:url(#\u672A\u547D\u540D\u6F38\u5C64_5);}.cls-4,.cls-5{fill-rule:evenodd;}.cls-4{fill:url(#\u672A\u547D\u540D\u6F38\u5C64_5-2);}.cls-6{fill:url(#\u672A\u547D\u540D\u6F38\u5C64_4);}.cls-7{fill:url(#\u672A\u547D\u540D\u6F38\u5C64_5-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u6F38\\u5C64_5",
    x1: 69.43,
    x2: 69.43,
    y2: 60.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#338fd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ca7e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u6F38\\u5C64_5-2",
    x1: 35.28,
    y1: 17.02,
    x2: 35.28,
    y2: 41.73,
    xlinkHref: "#\\u672A\\u547D\\u540D\\u6F38\\u5C64_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u6F38\\u5C64_4",
    x1: 214.3,
    y1: -613.01,
    x2: 307.1,
    y2: -624.41,
    gradientTransform: "translate(-214.2 668.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#2682ca",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#419dda",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ca7e0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u6F38\\u5C64_5-3",
    x1: 52.35,
    y1: 8.35,
    x2: 52.35,
    y2: 57.53,
    xlinkHref: "#\\u672A\\u547D\\u540D\\u6F38\\u5C64_5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5167\\u5BB9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.29,55.26c.06,2.39,1.25,6.9,9,6.9,4.22,0,8.92-1,8.92-5.53,0-3.32-3.21-4.21-7.73-5.28l-4.57-1.07c-6.9-1.61-13.55-3.16-13.55-12.54,0-4.76,2.55-13.14,16.4-13.14,13.08,0,16.58,8.56,16.64,13.79h-8.56c-.24-1.9-1-6.42-8.73-6.42-3.39,0-7.43,1.25-7.43,5.11,0,3.33,2.73,4,4.51,4.46l10.4,2.55c5.83,1.43,11.18,3.81,11.18,11.48,0,12.83-13.08,14-16.82,14-15.57,0-18.25-9-18.25-14.27Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.23,36.79h5.17v5.94h-5.17V59.9c0,1.84.06,2.56,3.45,2.56.54,0,1.13-.06,1.72-.12v6.3c-1.3.06-2.61.12-3.92.12h-1.07c-7.19,0-8.49-2.74-8.49-6.84V42.73h-4.28V36.79h4.28V28.23h8.31Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.3,62.23c0,3.73.83,4.57,1.84,4.92V68.4h-9a13.46,13.46,0,0,1-.77-3.74,12.9,12.9,0,0,1-10.23,4.58c-4.75,0-9.62-2.68-9.62-9.22,0-6.18,3.92-9.33,9.21-10.1l7.49-1.13c1.3-.18,2.91-.71,2.91-2.49,0-3.51-3.33-3.69-5.47-3.69-4.16,0-4.87,2.55-5.11,4.4h-8C175.51,37.32,182.22,36,188.7,36c4.46,0,12.6,1.37,12.6,9.15ZM193.16,53c-.83.65-2.2,1.19-5.65,1.72-3.09.53-5.64,1.31-5.64,4.76a3.62,3.62,0,0,0,3.86,3.8c3.69,0,7.43-2.38,7.43-6.24Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.05,36.79h5.16v5.94h-5.16V59.9c0,1.84.06,2.56,3.45,2.56.53,0,1.13-.06,1.71-.12v6.3c-1.3.06-2.6.12-3.91.12h-1.07c-7.19,0-8.5-2.74-8.5-6.84V42.73h-4.28V36.79h4.28V28.23h8.32Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.39,46.41c-.36-2-1.07-4.16-5.59-4.16s-5.11,1.73-5.11,3.09c0,5,19.79,1.37,19.79,13,0,9.21-8.92,10.88-13.84,10.88-7.2,0-15-2.51-15.21-10.94H235c0,2.67,1.67,4.63,6.89,4.63,4.29,0,5.3-2.07,5.3-3.27,0-5.29-19.62-1.3-19.62-13.13,0-4.63,2.91-10.58,12.78-10.58,6.18,0,13.54,1.55,14.2,10.46Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.85,68.4h-5.76V25.73h5.76Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.37,68.4h-5.23V49.26c0-5.4-1.55-8.14-6.66-8.14-3,0-8.2,1.91-8.2,10.34V68.4h-5.23V37.32H283v4.4h.12a11.26,11.26,0,0,1,9.39-5.29c4.81,0,10.88,2,10.88,10.82Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M328.74,46.18c-.07-2-.78-5.24-7.37-5.24-1.61,0-6.18.54-6.18,4.4,0,2.56,1.6,3.15,5.64,4.16l5.23,1.31c6.47,1.61,8.73,4,8.73,8.21,0,6.41-5.28,10.27-12.29,10.27-12.3,0-13.2-7.13-13.38-10.87h5.05c.18,2.44.9,6.36,8.26,6.36,3.75,0,7.13-1.49,7.13-4.94,0-2.49-1.71-3.32-6.18-4.46l-6.06-1.48c-4.34-1.07-7.19-3.27-7.19-7.55,0-6.83,5.64-9.92,11.77-9.92,11.11,0,11.88,8.2,11.88,9.75Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M340.91,31.67V25.73h5.23v5.94Zm5.23,36.73h-5.23V37.32h5.23Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.77,65.84c0,4.46-.06,15.63-14.45,15.63-3.68,0-10.87-1-11.88-9.26h5.23c.95,4.93,5.76,4.93,7,4.93,9,0,8.86-7.25,8.86-10.94V64.9h-.12v.24a9.35,9.35,0,0,1-8.26,4.15c-10.58,0-13.67-9.92-13.67-17.35,0-8.74,4.7-15.51,12.95-15.51,5.65,0,8,3.5,9.28,5.29h.12v-4.4h4.93Zm-13.49-1.06c3.33,0,8.49-2.2,8.49-10.46,0-5.06-.82-13.2-8.37-13.2-8.09,0-8.51,7.67-8.51,11.65C357.89,59.6,360.57,64.78,366.28,64.78Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.32,68.4h-5.23V48.08c0-4.22-1.18-7-6.18-7-4.27,0-8.67,2.5-8.67,10.34V68.4H387V25.73h5.23V41.48h.12c1.49-2,4.1-5,9.09-5,4.82,0,10.87,2,10.87,10.82Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M426.46,41.66v20.2c0,2.44,2.07,2.44,3.15,2.44h1.84v4.1c-1.9.18-3.38.41-3.92.41-5.17,0-6.31-2.9-6.31-6.65V41.66H417V37.32h4.21V28.65h5.24v8.67h5v4.34Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 62.66,
    width: 13.54,
    height: 60.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.05,17V41.34a24.28,24.28,0,0,0-13.55.39V17Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.21,44.36l-.05.18A17.86,17.86,0,0,1,38.1,47l-.75-1.29a.8.8,0,0,0-.48-.38.81.81,0,0,0-1,.57.73.73,0,0,0,.08.59l1.24,2.15c-.34.59-.77,1.24-1.26,1.94l-.56-1.44a.77.77,0,0,0-.42-.43.79.79,0,0,0-1.06,1l.91,2.34c-.62.73-1.18,1.34-1.72,1.88l-.26-1.45a.77.77,0,0,0-.33-.52.73.73,0,0,0-.59-.12.8.8,0,0,0-.52.32.78.78,0,0,0-.12.59l.45,2.49c-.57.52-1.19,1-1.87,1.54l-.09.08-.08-1.53a.79.79,0,0,0-.85-.75.84.84,0,0,0-.54.26.73.73,0,0,0-.2.57L28.23,58c-.6.39-1.23.77-1.85,1.12l.15-1.52a.83.83,0,0,0-.18-.59.76.76,0,0,0-.53-.27.78.78,0,0,0-.6.17.76.76,0,0,0-.27.53l-.25,2.54c-.63.3-1.3.58-2,.86L23,59.31a.78.78,0,0,0-.59-.94.81.81,0,0,0-.61.1.87.87,0,0,0-.35.49l-.55,2.45c-.85.24-1.61.43-2.28.58l.55-1.53a.79.79,0,0,0-1.07-1,.79.79,0,0,0-.41.45l-.86,2.36c-.63.08-1.08.11-1.32.12h-.18a20.75,20.75,0,0,1,23.85-18Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.63,66.34h-.17a21.19,21.19,0,0,0-3,.37l.55-1.4a.74.74,0,0,0,0-.6.78.78,0,0,0-.44-.43.76.76,0,0,0-.61,0,.78.78,0,0,0-.4.44l-.94,2.37s0,0,0,0a22.73,22.73,0,0,0-2.25.72l.33-1.44a.79.79,0,0,0-.1-.6.81.81,0,0,0-.5-.35.89.89,0,0,0-.6.1.76.76,0,0,0-.34.5l-.58,2.49a26.07,26.07,0,0,0-2.43,1.2l0-1.5a.78.78,0,0,0-.76-.82.8.8,0,0,0-.57.22.77.77,0,0,0-.24.55l-.09,2.5c-.69.44-1.35.91-2.07,1.45l-.09.06-.13-1.46a.79.79,0,0,0-.86-.7.8.8,0,0,0-.55.28.77.77,0,0,0-.17.58l.23,2.51c-.59.51-1.15,1-1.66,1.56l-.36-1.42a.77.77,0,0,0-1-.57.79.79,0,0,0-.58,1l.61,2.41a21.67,21.67,0,0,0-1.45,1.81l-.54-1.39a.82.82,0,0,0-.42-.44.78.78,0,0,0-.6,0,.82.82,0,0,0-.45.43.78.78,0,0,0,0,.6l.92,2.39h0c-.41.63-.8,1.29-1.17,2l-.66-1.22a.83.83,0,0,0-1.08-.32.81.81,0,0,0-.31,1.08l1.21,2.22a14.28,14.28,0,0,0-.57,1.5l0,.17a20.7,20.7,0,0,1-16.49-21.8h.17A13.47,13.47,0,0,0,17,63.24c.15.14.57.54,1.82,1.76a.78.78,0,0,0,.55.23h0A.8.8,0,0,0,20,63.86l-1-1c.72-.15,1.47-.35,2.23-.58l2.05,1.54a.76.76,0,0,0,.57.16.84.84,0,0,0,.55-.31.8.8,0,0,0-.16-1.11L23,61.7c.64-.24,1.34-.53,2.13-.9L27.3,62a.77.77,0,0,0,.61.08.76.76,0,0,0,.49-.37.81.81,0,0,0-.3-1.09l-1.27-.72c.64-.36,1.3-.75,1.94-1.18l2.37.91a.78.78,0,0,0,1-.44.8.8,0,0,0-.45-1l-1.37-.53.12-.09c.68-.51,1.33-1,1.93-1.58l2.44.6a.78.78,0,0,0,.61-.1.72.72,0,0,0,.34-.48.78.78,0,0,0-.09-.6.74.74,0,0,0-.49-.35l-1.46-.37c.62-.63,1.23-1.29,1.83-2l2.55.13a.77.77,0,0,0,.57-.2.81.81,0,0,0,.27-.54.82.82,0,0,0-.76-.85l-1.46-.07c.44-.62.87-1.27,1.3-2l2.56-.25a.8.8,0,0,0,.53-.3.75.75,0,0,0,.17-.57.79.79,0,0,0-.86-.72L39,47.49a19.83,19.83,0,0,0,1.16-2.77l.05-.16A20.68,20.68,0,0,1,56.63,66.34Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.55,67.32a20.73,20.73,0,0,1-23.82,18l0-.18c.09-.24.23-.66.46-1.23l2.52-.19a.77.77,0,0,0,.55-.27.82.82,0,0,0,.19-.57.81.81,0,0,0-.86-.74L34,82.29c.35-.66.75-1.34,1.2-2l2.49.14a.84.84,0,0,0,.57-.21.79.79,0,0,0-.49-1.39l-1.5-.08c.44-.59.88-1.14,1.35-1.69l2.51.46a.84.84,0,0,0,.58-.12.77.77,0,0,0,.34-.52.8.8,0,0,0-.13-.6.77.77,0,0,0-.51-.33l-1.51-.27c.51-.51,1-1,1.58-1.48l2.39.81a.73.73,0,0,0,.61,0,.74.74,0,0,0,.39-.46.79.79,0,0,0-.48-1L41.94,73l.11-.09c.66-.5,1.32-1,2-1.37l2.28,1.12a.8.8,0,0,0,1.06-.37.75.75,0,0,0,0-.62.77.77,0,0,0-.39-.44l-1.35-.65c.82-.44,1.57-.81,2.31-1.12l2,1.49a.79.79,0,0,0,.57.16.9.9,0,0,0,.56-.32.79.79,0,0,0-.17-1.1l-1.21-.92c.79-.29,1.54-.52,2.2-.69l1.72,1.76a.79.79,0,0,0,1.13,0,.84.84,0,0,0,.24-.58.76.76,0,0,0-.23-.54l-1-1.08a18.73,18.73,0,0,1,2.66-.33Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25,22.24v21a24.28,24.28,0,0,0-7.72,37.16.71.71,0,0,1-.36.09.92.92,0,0,1-.46-.14C-5.18,65.81-2.78,45,8.23,33.51,13.26,28.25,19.54,24.05,25,22.24Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.52,63.63l0,0a.9.9,0,0,1-.76.4.91.91,0,0,1-.92-.92,1.31,1.31,0,0,1,.25-.64C85,59.19,85.93,57,86,56.74a1.1,1.1,0,1,0-2-.87,63.49,63.49,0,0,1-9.49,14.7l-.16.16a1,1,0,0,1-.71.27,1.15,1.15,0,0,1-.81-2,67,67,0,0,0,4.77-6.46c.25-.4.49-.8.73-1.2s.47-.78.68-1.19.48-.87.7-1.31A36.74,36.74,0,0,0,84,43.39c0-1.2,0-7.76-4.29-9.78V20C86.5,23.8,90.88,29.54,92.06,37.8,93.37,46.86,90.49,55.87,84.52,63.63Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.27,75c-.41.38-.8.71-1.22,1s-.83.64-1.26,1a24,24,0,0,1-2.71,1.67,1.06,1.06,0,0,1-1.43-.45,1,1,0,0,1,.42-1.41h0a19.57,19.57,0,0,0,2.41-1.58c.39-.29.77-.59,1.15-.9s.74-.65,1.06-1h0a1.14,1.14,0,0,1,1.58,1.64Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25,22.24v21a24.28,24.28,0,0,0-7.72,37.16.71.71,0,0,1-.36.09.92.92,0,0,1-.46-.14C-5.18,65.81-2.78,45,8.23,33.51,13.26,28.25,19.54,24.05,25,22.24Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.52,63.63l0,0a.9.9,0,0,1-.76.4.91.91,0,0,1-.92-.92,1.31,1.31,0,0,1,.25-.64C85,59.19,85.93,57,86,56.74a1.1,1.1,0,1,0-2-.87,63.49,63.49,0,0,1-9.49,14.7l-.16.16a1,1,0,0,1-.71.27,1.15,1.15,0,0,1-.81-2,67,67,0,0,0,4.77-6.46c.25-.4.49-.8.73-1.2s.47-.78.68-1.19.48-.87.7-1.31A36.74,36.74,0,0,0,84,43.39c0-1.2,0-7.76-4.29-9.78V20C86.5,23.8,90.88,29.54,92.06,37.8,93.37,46.86,90.49,55.87,84.52,63.63Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M70.27,75c-.41.38-.8.71-1.22,1s-.83.64-1.26,1a24,24,0,0,1-2.71,1.67,1.06,1.06,0,0,1-1.43-.45,1,1,0,0,1,.42-1.41h0a19.57,19.57,0,0,0,2.41-1.58c.39-.29.77-.59,1.15-.9s.74-.65,1.06-1h0a1.14,1.14,0,0,1,1.58,1.64Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M59.12,8.35V57.53a24.37,24.37,0,0,0-13.54-15V8.35Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f73480ceb7ddacd618cc792e2c55e553.svg";
export { ForwardRef as ReactComponent };